import { createSlice } from "@reduxjs/toolkit"

// WICG Spec: https://wicg.github.io/ua-client-hints

// declare interface Navigator extends NavigatorUA {}
// declare interface WorkerNavigator extends NavigatorUA {}

// https://wicg.github.io/ua-client-hints/#navigatorua
export declare interface NavigatorUA {
  readonly userAgentData?: NavigatorUAData
}

// https://wicg.github.io/ua-client-hints/#dictdef-navigatoruabrandversion
interface NavigatorUABrandVersion {
  readonly brand: string
  readonly version: string
}

// https://wicg.github.io/ua-client-hints/#dictdef-uadatavalues
interface UADataValues {
  readonly brands?: NavigatorUABrandVersion[]
  readonly mobile?: boolean
  readonly platform?: string
  readonly architecture?: string
  readonly bitness?: string
  readonly formFactor?: string[]
  readonly model?: string
  readonly platformVersion?: string
  /** @deprecated in favour of fullVersionList */
  readonly uaFullVersion?: string
  readonly fullVersionList?: NavigatorUABrandVersion[]
  readonly wow64?: boolean
}

// https://wicg.github.io/ua-client-hints/#dictdef-ualowentropyjson
interface UALowEntropyJSON {
  readonly brands: NavigatorUABrandVersion[]
  readonly mobile: boolean
  readonly platform: string
}

// https://wicg.github.io/ua-client-hints/#navigatoruadata
interface NavigatorUAData extends UALowEntropyJSON {
  getHighEntropyValues(hints: string[]): Promise<UADataValues>
  toJSON(): UALowEntropyJSON
}
declare global {
  interface Navigator {
    userAgentData: NavigatorUAData
  }
}

//userAgentを解析し、タブレットページに移行
//TODO: chromeは2021年以降将来的にuserAgentが使用不可になるため、そのための分岐を作成
let isTablet: boolean = false
let isWindows: boolean = false

if ("userAgentData" in window.navigator) {
  // 新仕様
  isTablet =
    window.navigator.userAgentData.mobile ||
    window.navigator.userAgentData.platform.match(/(iPhone|iPad|Android)/i) !=
      null
} else {
  isTablet = navigator.userAgent.match(/(iPhone|iPad|Android)/i) != null
}

const initialState: {
  isTablet: boolean
  isWindows: boolean
} = { isTablet, isWindows }

export const terminalSlice = createSlice({
  name: "alert",
  initialState,
  reducers: {
    changeTablet: (state) => {
      state.isTablet = true
    },
    changeWebApp: (state) => {
      state.isTablet = false
    },
    checkWindows: (
      state,
      action: {
        payload: boolean
        type: string
      }
    ) => {
      state.isWindows = action.payload
    },
  },
})

export const { changeTablet, changeWebApp, checkWindows } =
  terminalSlice.actions
